import { getConfigForBaseUrl } from '~/server/config/siteConfig'
import type { BrandConfig } from '~/server/config/siteConfig'

export default defineNuxtPlugin((nuxtApp) => {

    const runtimeConfig = useRuntimeConfig()
    const baseUrl = runtimeConfig.public?.siteName
    const config = getConfigForBaseUrl(baseUrl)

    const siteConfig = useState<BrandConfig>('siteConfig', () => config)

    if (nuxtApp.ssrContext) {
        const event = useRequestEvent()
        const fromCtx = event?.context?.siteConfig as BrandConfig | undefined
        // Trust the request-scoped middleware result; fall back to plugin-time
        // resolution if the middleware didn't run for some reason.
        siteConfig.value = fromCtx ?? config
    }

    return {
        provide: {
            siteConfig
        }
    }
})

